// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../assets/stylesheets/variables.css\"","body":"_2lYHSCAcM6vA2s-47YYZeS","paddedForNavbar":"_15-uIrn7gODHiOpUuDWjwC","title":"_2sstP9_n-b2CqLuTjQKwU4 _2IbHD4FVxtBnbNHEUw2mS3","genericContainer":"_2ELtkcMpIJZ1yyH_kfj3I7","mobileThreshold":"575px","container":"_1BPUoQEKgh9y3Iepc-UL9o _15-uIrn7gODHiOpUuDWjwC","mainContent":"_2Ps--SzZWoaDOoA_97oIDW _2ELtkcMpIJZ1yyH_kfj3I7","instructions":"_1LZwvEgk-kEx-PjVRA1pFL _2lYHSCAcM6vA2s-47YYZeS","form":"_2TiXovr6aqRF-XJbmVTTlp"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/forgot-password/ForgotPassword.css
// module id = 848
// module chunks = 0